import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { MemberData } from '../catalogue-our-team.model'
import { NgForm } from '@angular/forms';
import { EditorConfig } from '@root/app.constant';
import { CatalogService } from '../../catalog.service';
import {
  MAX_FILE_SIZE,
  Maximum_file_size_540kb,
  format_not_allowed,
} from '@root/app.constant';
import { FileInputComponent } from '@root/common/file-input/file-input';
import { ToastrService } from 'ngx-toastr';
import { ConfirmOrderComponent } from '../../shared/confirm-order/confirm-order.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-catalouge-add-team-member',
  templateUrl: './catalouge-add-team-member.component.html',
  styleUrls: ['./catalouge-add-team-member.component.scss']
})
export class CatalougeAddTeamMemberComponent implements OnInit {

  constructor(private catalogService: CatalogService, private toastr: ToastrService, private dialog:MatDialog) { }
  @Input() MemberData: MemberData;
  @Output() refreshChange = new EventEmitter<string>();
  @ViewChild('f', { static: false }) form: NgForm;
  @ViewChild(FileInputComponent, { static: false }) fileInputComponent: FileInputComponent;

  Teams: any;
  editorConfig = EditorConfig;
  file: File;
  fileName: string;

  ngOnInit() {
    this.getTeamList()

  }
  getTeamList() {
    this.catalogService.getTeamList().subscribe((resp) => {
      if(resp.status === 0){
        this.Teams = resp.data.subSectionData['About Us']

      }
      else {
        this.toastr.error(resp.error.errorMessage);
      }
    },

      (error) => {
        this.toastr.error(error.errorMessage);

      })
  }

  public onFileChange(file: File) {
    this.file = file;
    if (this.file) {
      this.validateImage();
    } else {
      this.fileName = null;

    }
  }

  private validateImage() {
    let isValid = true;
    const fsize = this.file.size;
    if (fsize > MAX_FILE_SIZE) {
      this.toastr.error(Maximum_file_size_540kb);
      isValid = false;
      this.clearFileComponent();
    } else if (this.file.type !== 'image/jpeg' && this.file.type !== 'image/png') {
      this.toastr.error(format_not_allowed);
      isValid = false;
      this.clearFileComponent();
    }
  }


  private clearFileComponent() {
    if (this.fileInputComponent) {
      this.fileInputComponent.clear();
      this.file = null;
      setTimeout(() => {
        this.fileName = null;
      });
    }
  }


  public processData(displayOrder?:String) {
    this.MemberData.imageUrl = this.fileName;
  
    // Assign sectionId if subSectionName matches
    const matchedTeam = this.Teams.find(ele =>
      ele.subSectionName && 
      this.MemberData.subSectionName &&
      ele.subSectionName.trim().toLowerCase() === this.MemberData.subSectionName.trim().toLowerCase()
    );
    this.MemberData.sectionId = matchedTeam ? matchedTeam.id : this.MemberData.sectionId;
  
    // Prepare form data
    const formData = new FormData();
    formData.append('description', this.MemberData.description.toString());
    formData.append('title', this.MemberData.title.toString());
    formData.append('subsectionId', this.MemberData.sectionId.toString());
    formData.append('position', this.MemberData.position?this.MemberData.position.toString():null);
    formData.append('orderOfDisplay', this.MemberData.orderOfDisplay.toString());
    if(displayOrder && displayOrder === 'moveExistingToNextPosition'){
      formData.append('moveExistingToNextPosition', "yes")
    }
    else if(displayOrder && displayOrder === 'swapOrder'){
      formData.append('swapOrder', "yes")
    }
  
  
    // Append photo if it exists
    if (this.file) {
      formData.append('photo', this.file);
    }
    else{
      formData.append('photo', null);
    }
  
    // Append id if updating an existing member
    if (this.MemberData.id) {
      formData.append('id', this.MemberData.id.toString());
      this.catalogService.updateTeamMember(formData).subscribe(
        (resp) => {
          if(resp.status === 0){
            this.toastr.success(resp.message);
            this.resetForm();
            this.refreshChange.emit();
          }else {
            if(resp.error.errorCode === -105){
              this.openConfirmDialog(resp.error.errorMessage)
            }
            else{
              this.toastr.error(resp.error.errorMessage);

            }
          
          }
        
       
        },
        (err) => {
          this.toastr.error(err.errorMessage);
        }
      );
    } else {
      // Add new team member
      this.catalogService.addTeamMember(formData).subscribe(
        (resp) => {
          if(resp.status === 0){
            this.toastr.success(resp.message);
            this.resetForm();
            this.refreshChange.emit();
          }
          else {
            if(resp.error.errorCode === -105){
              this.openConfirmDialog(resp.error.errorMessage)
            }
            else{
              this.toastr.error(resp.error.errorMessage);

            }
          
          }
      
        },
        (err) => {
          this.toastr.error(err.errorMessage);
        }
      );
    }
  }
  
  
  
  
  public resetForm() {
    if (this.form) {
      this.form.resetForm();
      this.MemberData.id='';
      this.MemberData.sectionId = ''
    }
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.charCode || event.keyCode;
    // Allow only numbers (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  public openConfirmDialog(message) {
    const dialogRef = this.dialog.open(ConfirmOrderComponent, {
      width: '600px',
      data: { message: message},
    });
    dialogRef.afterClosed().subscribe((result) => {
   if(result.result === 'ok'){
  
    this.processData('moveExistingToNextPosition')
   }
   else if(result.result === 'swap'){
    this.processData('swapOrder')
   }
    });

  }
}

